import ApperIcon from '@/components/ApperIcon';

export default function WorkflowHeader({ icon, eyebrow, title, description, children }) {
  return (
    <header className="picketops-workflow relative overflow-hidden rounded-2xl border border-border p-5 shadow-(--shadow-sm) md:p-7">
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-0.5 bg-primary"/>
      <div aria-hidden="true" className="pointer-events-none absolute -right-6 -top-8 hidden size-36 items-center justify-center text-primary/5 md:flex">
        <ApperIcon name={icon} size={112}/>
      </div>
      <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-5">
        <div className="flex items-start gap-4 min-w-0">
          <span className="hidden sm:flex size-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <ApperIcon name={icon} size={25} aria-hidden="true"/>
          </span>
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary">{eyebrow}</p>
            <h1 className="mt-2 text-3xl md:text-4xl font-heading font-bold tracking-tight">{title}</h1>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground max-w-2xl">{description}</p>
          </div>
        </div>
        {children && <div className="flex flex-wrap items-center gap-2 shrink-0">{children}</div>}
      </div>
    </header>
  );
}
